//@ts-nocheck
import React from "react";
import { useRouteMatch } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';
import { ApplicationState } from '../../../reducers/Index';
import { numberWithCommas } from '../../Common/Helpers';
import { FilterEarlyCareerReport, loadEarlyCareerReportCounts, handleFilterSelection, clearFilterSelection, setFilterValues, clearAllData } from '../../../actions/EarlyCareerReportActions';
import { Heading1, Heading2, Heading3, IRISLightGreyDivider, ReportText, TextLink, TextSpan } from '../../Common/SharedStyledComponents';
import styled, { css } from "styled-components";
import { Form } from "react-bootstrap";
import "./EarlyCareerReportMenu.css";
import { EarlyCareerReportAction } from '../../../interface/EarlyCareerReportInterface';
import Select from 'react-select';

interface Props {
    //loadEarlyCareerReportCounts?: any; //already declared in EarlyCareerReportAction
    UserState?: any;
    EarlyCareerReportState?: any;
}

class EarlyCareerReportMenu extends React.Component<Props & EarlyCareerReportAction, {}> {
    constructor(props) {
        super(props);
       // this.getSelectedComparisonValue = this.getSelectedComparisonValue.bind(this);
        this.handleComparisonValueChange = this.handleComparisonValueChange.bind(this);
    }

    const comparisonValueOptions = [
        { value: "1", label: " ", description: "" },
        { value: "2", label: "Early Career Award", description: "“ECA yes” indicates researchers who have won early career awards from NSF, NIH, and DOD; “ECA no” indicates those who haven’t" },
        { value: "3", label: "Gender", description: "M indicates male and F indicates female; these data only include researchers for whom gender can be imputed from their names." },
    ];

    //getSelectedComparisonValue() {
    //    const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;

    //    console.log(filterSelection);
    //    if (filterSelection.checked_ecr_award_compare)
    //        return { value: "1", label: "Early Career Award" };
    //    else if (filterSelection.checked_gender_compare)
    //        return { value: "2", label: "Gender" };
    //}

    handleComparisonValueChange(value) {
        if (value.value == "1") {
            this.props.handleFilterSelection("checked_ecr_award_compare", false);
            this.props.handleFilterSelection("checked_no_compare", true);
            this.props.handleFilterSelection("checked_gender_compare", false);
        }
        else if (value.value == "2") {
            this.props.handleFilterSelection("checked_ecr_award_compare", true);
            this.props.handleFilterSelection("checked_no_compare", false);
            this.props.handleFilterSelection("checked_gender_compare", false);
        }
        else {
            this.props.handleFilterSelection("checked_ecr_award_compare", false);
            this.props.handleFilterSelection("checked_no_compare", false);
            this.props.handleFilterSelection("checked_gender_compare", true);
        }
    }

    handleApply() {
        const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;

        const updated_ecr_award = [], updated_gender = [], updated_suborg = [], updated_funder = [];

        if (filterSelection.checked_1) updated_ecr_award.push('1');
        if (filterSelection.checked_0) updated_ecr_award.push('0');

        if (filterSelection.checked_M) updated_gender.push('M');
        if (filterSelection.checked_F) updated_gender.push('F');
        if (filterSelection.checked_U) updated_gender.push('U');

        if (filterSelection.checked_suborg1) updated_suborg.push('suborg1');
        if (filterSelection.checked_suborg2) updated_suborg.push('suborg2');
        if (filterSelection.checked_suborg3) updated_suborg.push('suborg3');
        if (filterSelection.checked_suborg4) updated_suborg.push('suborg4');
        if (filterSelection.checked_suborg5) updated_suborg.push('suborg5');

        if (filterSelection.checked_NIH) updated_funder.push('NIH');
        if (filterSelection.checked_NSF) updated_funder.push('NSF');
        if (filterSelection.checked_nonfed) updated_funder.push('nonfed');
        if (filterSelection.checked_otherfunder) updated_funder.push('otherfunder');

        this.props.setFilterValues("ecr_award", updated_ecr_award);
        this.props.setFilterValues("gender", updated_gender);
        this.props.setFilterValues("suborg", updated_suborg);
        this.props.setFilterValues("funder", updated_funder);

        this.props.setFilterValues("no_compare", filterSelection.checked_no_compare)
        this.props.setFilterValues("ecr_award_compare", filterSelection.checked_ecr_award_compare)
        this.props.setFilterValues("gender_compare", filterSelection.checked_gender_compare)

        //after clear it fetches new data
        this.props.clearAllData(
            this.props.FilterEarlyCareerReport,
            this.props.UserState.report_display_id,
            {
                ecr_award: updated_ecr_award,
                gender: updated_gender,
                suborg: updated_suborg,
                funder: updated_funder,
                no_compare: filterSelection.checked_no_compare,
                ecr_award_compare: filterSelection.checked_ecr_award_compare,
                gender_compare: filterSelection.checked_gender_compare
            },
            this.props.UserState.report_vintage_early_career
        );
    }

    handleClear(event) {
        this.props.handleFilterSelection('checked_no_compare', true);
        this.props.handleFilterSelection('checked_ecr_award_compare', false);
        this.props.handleFilterSelection('checked_gender_compare', false);

        this.handleApply();
    }

    handleRadioChange(key, event) {
        //no comparison
        if (key == 0) {
            this.props.handleFilterSelection("checked_no_compare", event.target.checked);
            this.props.handleFilterSelection("checked_ecr_award_compare", !event.target.checked);
            this.props.handleFilterSelection("checked_gender_compare", !event.target.checked);
        }
        //ecr award comparison
        else if (key == 1) {
            this.props.handleFilterSelection("checked_ecr_award_compare", event.target.checked);
            this.props.handleFilterSelection("checked_no_compare", !event.target.checked);
            this.props.handleFilterSelection("checked_gender_compare", !event.target.checked);
        }
        //gender comparison
        else if (key == 2) {
            this.props.handleFilterSelection("checked_gender_compare", event.target.checked);
            this.props.handleFilterSelection("checked_ecr_award_compare", !event.target.checked);
            this.props.handleFilterSelection("checked_no_compare", !event.target.checked);
        }
    }

    handleChange(key, event) {
    }

    render() {
        const filterSelection = this.props.EarlyCareerReportState.EarlyCareerReportFilterSelection;
        let selectedComparisonValue = {
            value: "1", label: " "
        };
        if (filterSelection != null) {
            if (filterSelection.checked_no_compare)
                selectedComparisonValue = { value: "1", label: " ", description: "" };
            else if (filterSelection.checked_ecr_award_compare)
                selectedComparisonValue = { value: "2", label: "Early Career Award", description: "“ECA yes” indicates researchers who have won early career awards from NSF, NIH, and DOD; “ECA no” indicates those who haven’t." };
            else {
                selectedComparisonValue = { value: "3", label: "Gender", description: "M indicates male and F indicates female; these data only include researchers for whom gender can be imputed from their names." };
            }
        }

        return (
            <Aside>
                <StickyContainer>
                    <FilterContainer className="filter-container rightmenu-container">
                        <Heading3 bold>Comparison</Heading3>
                        <p style={{ width: "100%", textAlign: "left" }}>Selecting one of the categories below will display two sets of data in each chart for easy comparisons. The entire population of data shown in the charts can be filtered using the boxes to the left.</p>
                        <Select className="ecrComparisonValue"
                            name="ecrComparisonValue"
                            value={selectedComparisonValue}
                            options={this.comparisonValueOptions}
                            onChange={this.handleComparisonValueChange}
                        />
                        <div style={{ paddingTop: "10px" }}>
                            <button className="filter" onClick={this.handleApply.bind(this)}>Apply</button>
                            <button className="cancel" onClick={this.handleClear.bind(this)}>Clear</button>
                        </div>
                        <span style={{ display: "inline-block", margin: "20px 6px 0px 6px", fontSize: "14px", fontWeight: "bold", color: "#7e6a11" }} >{selectedComparisonValue.description}</span>
                    </FilterContainer>
                </StickyContainer>
            </Aside>);
    }
}


const Aside = styled.div`
`;

const StickyContainer = styled.div`
    position: fixed;
    top: 110px;
    background: white;
    padding-inline: 5px;
    padding-bottom: 10px;
    border-radius: 0px;
    border: solid 1px #D3D3D3;
    height: 450px;
    width: 300px;
    z-index: 50;
`;

const ReportNavContainer = styled.div`
    padding: 10px;
`;

const ReportNavListItem = styled.p`
    font-size: 14px;
    text-align: left;
    margin-block: 5px;
    ${props => props.indented && css`
        margin-left: 15px;
    `}
`;

const FilterContainer = styled.div`
    padding-inline: 10px;
    font-size: 12px;
`;

const CheckboxGroup = styled.div`
    max-height: 500px;
`;


function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadEarlyCareerReportCounts: loadEarlyCareerReportCounts,
            handleFilterSelection: handleFilterSelection,
            clearFilterSelection: clearFilterSelection,
            setFilterValues: setFilterValues,
            FilterEarlyCareerReport: FilterEarlyCareerReport,
            clearAllData: clearAllData
        }, dispatch
    );
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    EarlyCareerReportState: state.earlyCareerReportProperties
});

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(EarlyCareerReportMenu, "Early Career Report Menu", "landing page"));



